<template>
  <vs-prompt
    class="custom-modal p-0"
    :class="[{'is-mobile': isMobile, 'show': showAnimation, 'dynamic-height': !fixedHeight, 'min-height': hasMinHeight}, `${size ? size + '-' : ''}prompt`]"
    :buttons-hidden="true"
    title=""
    :active="showModal"
    @close="handleCloseModal">

    <slot name="header">
      <div v-if="checkModalHasHeader" class="prompt-header p-3 w-full" :class="[!$vs.rtl ? 'rtl-only' : '']">
        <vs-row>
          <vs-col v-if="getHeaderRightActions.length > 0" class="w-1/5 useral-font-weight-medium text-success cursor-pointer flex">
            <slot name="rightActions">
              <template v-for="(action, key) in getHeaderRightActions">

                <div :key="key" @click="$emit(action.event)">
                  <custom-icon :icon="action.icon" :color="action.color"/>
                </div>
              </template>
            </slot>
          </vs-col>

          <vs-spacer/>

          <vs-col class="w-1/2 text-center useral-font-weight-bold text-md">
            <slot name="title">{{ title }}</slot>
          </vs-col>

          <vs-spacer/>

          <vs-col v-if="getHeaderLeftActions.length > 0" class="w-1/5 text-right useral-font-weight-medium text-danger cursor-pointer flex">
            <slot name="leftActions">
              <template v-for="(action, key) in getHeaderLeftActions">
                <div :key="key" @click="$emit(action.event)">
                  <custom-icon :icon="action.icon" :color="action.color"/>
                </div>
              </template>
            </slot>
          </vs-col>
        </vs-row>
      </div>
    </slot>

    <slot name="content">
      <div class="prompt-content p-2" :style="contentStyle">
        <template>
          <keep-alive>
            <slot></slot>
          </keep-alive>
        </template>
        <div v-if="getFooterActions.length > 0" class="footer-actions">
          <template v-for="(action, key) in getFooterActions">
            <div :key="key" class="footer-action-item">
              <vs-button class="w-full"
                         :color="action.color"
                         @click="$emit(action.event)">
                {{ action.name }}
              </vs-button>
            </div>
          </template>
        </div>
      </div>
    </slot>
  </vs-prompt>
</template>

<script>
import CustomIcon from '@/components/icon/customIcon.vue'
import {mapGetters} from 'vuex'

export default {
  name: 'customModal',
  components: {CustomIcon},
  props: {
    active: {
      type: Boolean,
      default: false
    },
    fixedHeight: {
      type: Boolean,
      default: true
    },
    hasMinHeight: {
      type: Boolean,
      default: true
    },
    checkChange: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    contentStyle: {
      type: [String, Object],
      default: () => { return {} }
    },
    size: {
      type: String,
      default: '',
      validator (val) {
        return ['', 'very-small', 'small', 'medium', 'big', 'very-big', 'full-screen'].includes(val)
      }
    },
    actions: {
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
      modalTimer: 0,
      showModal: false,
      showAnimation: false
    }
  },
  computed: {
    ...mapGetters({
      isMobile: 'isMobile'
    }),
    getHeaderRightActions () {
      return this.actions.filter(elm => elm.position === 'header-right').map(elm => elm.action)
    },
    getHeaderLeftActions () {
      return this.actions.filter(elm => elm.position === 'header-left').map(elm => elm.action)
    },
    getFooterActions () {
      return this.actions.filter(elm => elm.position === 'footer').map(elm => elm.action)
    },
    checkModalHasHeader () {
      return this.$slots.rightActions || this.$slots.leftActions || this.getHeaderRightActions.length > 0 || this.getFooterActions.length > 0 || this.title.length > 0
    }
  },
  created () {
    this.handleChangeActiveStatus(this.active)
  },
  watch: {
    active: {
      handler (val) {
        this.handleChangeActiveStatus(val)
      }
    }
  },
  methods: {
    handleCloseModal () {
      if (this.$store.state.pageHaveChanges && this.checkChange) {
        const answer = window.confirm(this.$t('others.alert.unsavedChanges'))

        if (answer) {
          this.$store.dispatch('removePageChanges')
        } else {
          return false
        }
      }
      if (this.isMobile) {
        this.showModal = true
        this.$emit('close')
      } else {
        this.$emit('close')
      }
    },
    handleChangeActiveStatus (status) {
      if (status) {
        this.showModal = true
        this.$nextTick(() => {
          this.showAnimation = true
        })
      } else {
        this.showAnimation = false
        if (this.isMobile) {
          clearTimeout(this.modalTimer)
          this.modalTimer = setTimeout(() => {
            // this.$emit('close')
            this.showModal = false
          }, 250)
        } else {
          // this.$emit('close')
          this.showModal = false
        }
      }
    }
  }
}
</script>

<style lang="scss">
.custom-modal {
  /*&.is-mobile {
    align-items: end;

    .vs-dialog {
      -webkit-animation: rebound-mobile .3s;
      animation: rebound-mobile .3s;
      transition: all 0.3s ease-in-out;
    }

    &:not(.show) {
      .vs-dialog {
        transform: translateY(100%);
      }
    }

    &.show {
      .vs-dialog {
        transform: translateY(0);
      }
    }

    .footer-actions {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      margin-top: 10px;

      .footer-action-item {
        flex: 1
      }
    }

    &.con-vs-dialog {
      .vs-dialog {
        margin: 0;
        width: 100%;
        border-radius: 0.5rem 0.5rem 0 0 !important;
      }
    }

    @keyframes rebound-mobile {
      0% {

        transform: translateY(100%);
      }
      100% {

        transform: translateY(0);
      }
    }
  }*/
}
</style>
